module.exports = __webpack_public_path__ + "img/module-title-01_blue.7cf0a35b.jpg";